import WithoutATeam from './WithoutATeam';
export default WithoutATeam;
